import script from "./QuestionField.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionField.vue?vue&type=script&setup=true&lang=js"

import "./QuestionField.vue?vue&type=style&index=0&id=59348bc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59348bc0"]])

export default __exports__